module.exports = new __parcel__URL__("showoff.22672bdf.png").toString();